var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g, _path81, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackTarotCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 168,
    viewBox: "0 0 104 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79875 3.1001L97.2988 4.1001L101.299 11.68L98.7988 164.1L12.7988 165.1L5.79875 164.1L4.29875 8.65182L5.79875 3.1001Z",
    fill: "#EDECF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2988 3.1C86.587 3.01102 87.8931 3.37002 88.2986 4.1C88.6596 4.74969 90.9531 6.7783 91.48 7.30513C93.2251 9.05024 94.7507 11.0341 96.3368 12.9086C97.4991 14.2821 98.5664 15.653 99.3724 17.265C99.5927 17.7057 99.9541 18.5869 100.332 18.8894C100.871 19.3206 100.997 20.514 101.588 20.8092",
    stroke: "url(#paint0_linear_213_16515)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2988 2.6001C77.5249 2.6001 79.9816 4.77314 80.1744 5.04087C80.8043 5.91577 81.5176 6.7709 82.209 7.60057C83.9771 9.72232 85.9552 11.7141 87.8863 13.6881C89.7462 15.5893 91.3672 17.592 93.0221 19.6607C94.0634 20.9623 95.5103 22.725 95.9756 24.3535C96.3048 25.5056 97.3352 26.2998 97.6083 27.5285C97.7538 28.1835 98.171 28.79 98.5682 29.3006C99.3934 30.3616 100.662 31.0691 101.292 32.328",
    stroke: "url(#paint1_linear_213_16515)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7988 3.1001C70.7988 3.54664 71.8591 4.93266 72.111 5.2815C72.8047 6.24192 73.4214 7.25763 74.1375 8.20219C75.0312 9.3812 76.3627 10.3756 77.3617 11.4921C78.503 12.7676 79.7623 13.9312 80.8977 15.2086C82.0385 16.4919 83.3651 17.6432 84.5814 18.8594C85.6186 19.8966 86.8578 20.8597 87.8057 21.9688C89.3287 23.7511 90.9021 25.6231 92.5641 27.2851C93.1873 27.9083 93.8172 28.3968 94.328 29.1311C94.7709 29.7677 95.2705 30.4191 95.8129 30.977C96.6828 31.8718 97.5898 32.8938 98.3234 33.8977C98.6982 34.4105 99.2329 34.8892 99.5376 35.4073C99.7719 35.8056 100.451 36.8401 100.834 37.0317",
    stroke: "url(#paint2_linear_213_16515)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2988 3.1001C64.2988 3.66493 66.9501 5.39045 67.327 5.74643C68.0897 6.46669 68.687 7.19317 69.2468 8.10923C71.2737 11.426 74.2151 14.1719 76.6306 17.1913C77.9687 18.864 79.5765 20.2461 80.9132 21.9169C82.238 23.5729 83.7161 25.1944 85.1957 26.7163C87.3868 28.97 89.5826 31.3836 91.5458 33.8376C92.9077 35.5399 94.7239 36.9929 95.9022 38.8257C96.4866 39.7347 97.2786 40.4705 98.1173 41.1229C98.6349 41.5254 99.5979 42.2809 99.9305 42.8129C100.225 43.285 101.83 44.3169 100.554 43.5513",
    stroke: "url(#paint3_linear_213_16515)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7954 5.15571C59.7782 5.1042 58.0093 3.46381 58.2988 3.60008C58.5814 3.73305 59.9683 5.23664 60.1235 5.48388C61.037 6.93871 62.3448 8.23206 63.4134 9.57777C66.3807 13.3143 69.5015 16.9589 72.4626 20.6944C75.4374 24.4472 78.1715 28.3972 81.2083 32.0983C82.3563 33.4974 83.682 34.8672 85.0479 36.0527C86.4228 37.246 87.5334 38.653 88.8136 39.9333C90.5634 41.6831 91.9194 43.7448 93.6951 45.4711C94.7137 46.4614 95.5775 47.567 96.7962 48.3425C97.6945 48.9142 98.6045 49.7242 99.3724 50.492C99.6791 50.7988 99.9941 51.1216 100.258 51.4519C100.352 51.5685 100.839 51.9688 100.701 51.9688",
    stroke: "url(#paint4_linear_213_16515)",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8548 3.97437C52.6127 4.00462 53.7574 5.38807 53.9213 5.59879C54.8375 6.7768 55.7503 8.00604 56.7271 9.143C58.2593 10.9264 59.6367 12.7983 61.0918 14.6398C62.5755 16.5177 64.3869 18.017 66.0717 19.7018C67.9624 21.5925 69.7907 23.5199 71.4619 25.6088C73.0492 27.5929 74.5492 29.6527 76.1957 31.5897C77.7079 33.3688 79.1595 35.2039 80.6834 36.9716C81.9145 38.3997 83.2224 39.7913 84.3096 41.3362C86.0617 43.826 88.2443 45.6993 90.3315 47.8668C91.6351 49.2205 92.9543 50.5717 94.2777 51.895C94.8099 52.4272 95.4726 52.8752 96.0498 53.3636C96.5387 53.7772 97.2775 54.2753 97.6004 54.8403C97.8073 55.2024 98.4074 55.434 98.708 55.7346C99.2794 56.306 99.7416 56.7607 100.259 57.4328",
    stroke: "url(#paint5_linear_213_16515)",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2988 3.1001C45.0253 3.34321 46.6602 4.29886 46.8818 4.64707C47.2081 5.15984 47.5105 5.69682 47.8663 6.18945C49.1253 7.93259 50.248 9.77038 51.5254 11.5058C53.1633 13.7308 54.6937 16.0714 56.5135 18.1512C58.4986 20.4197 60.4594 22.7683 62.3385 25.1247C63.2787 26.3036 64.4405 27.2685 65.4069 28.4228C66.4673 29.6894 67.5334 30.9376 68.6229 32.1803C70.5306 34.3563 72.5614 36.3361 74.7104 38.2678C75.8061 39.2527 76.6918 40.4652 77.8116 41.41C78.811 42.2532 79.8077 43.1846 80.7323 44.1092C82.0989 45.4758 83.3665 46.9285 84.7524 48.2769C85.8751 49.3694 87.1599 50.2662 88.2638 51.4109C89.1189 52.2978 89.9661 53.1954 90.8399 54.0691C91.5682 54.7975 92.3738 55.3822 93.2027 55.9561C93.837 56.3952 94.8867 56.7809 95.2701 57.4328C95.5866 57.9708 96.4479 58.6256 96.9766 58.9916C97.5198 59.3677 97.9969 60.0447 98.4862 60.534C99.659 61.7068 99.265 61.8332 100.799 62.6001",
    stroke: "url(#paint6_linear_213_16515)",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7113 4.56503C39.6377 4.56503 37.7988 2.47834 37.7988 2.6001C37.7988 2.70977 39.5393 4.54754 39.6292 4.57323C39.9512 4.66521 40.45 5.56861 40.663 5.82027C41.4545 6.75567 42.4921 7.33192 43.1817 8.40459C43.9684 9.62837 44.6214 10.9958 45.6511 12.0637C46.9641 13.4253 48.1879 15.0294 49.343 16.5267C52.4801 20.5933 56.0479 24.3751 59.0568 28.5541C60.5141 30.5782 62.2028 32.5206 63.9629 34.2806C65.8735 36.1913 68.1712 37.5618 70.2473 39.2687C72.3984 41.0374 74.2254 43.0664 76.1871 45.0281C77.9213 46.7622 79.7195 48.5182 81.3557 50.3362C84.1468 53.4374 88.143 55.2571 91.1351 58.1384C92.2619 59.2234 93.3596 60.5585 94.5727 61.5021C95.4605 62.1926 96.2835 62.9094 97.0832 63.709C97.77 64.3958 98.3345 65.1204 98.9619 65.8175C99.233 66.1187 101.612 67.4754 100.299 67.1001",
    stroke: "url(#paint7_linear_213_16515)",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2991 3.1001C31.2759 3.1001 32.9247 4.79703 33.1029 4.97523C33.7128 5.58516 34.255 6.28644 34.916 6.84579C36.5838 8.25698 37.7646 10.3939 39.1576 12.0965C42.6869 16.4101 45.6877 21.1233 49.3144 25.3544C51.2087 27.5645 53.2821 29.494 55.369 31.5158C57.7112 33.7848 60.2966 35.7788 62.6051 38.0873C64.7785 40.2607 66.7935 42.2204 68.5121 44.7984C69.9528 46.9594 71.391 49.1932 73.0983 51.1566C74.7338 53.0375 76.5965 54.6278 78.3736 56.3663C79.9029 57.8623 81.854 58.954 83.5668 60.2386C86.5286 62.4599 89.5082 64.6072 92.4355 66.884C93.1048 67.4045 93.7543 67.9075 94.3553 68.5085C94.8355 68.9886 95.4649 69.2584 95.947 69.7227C96.5886 70.3405 97.7954 70.7649 98.0555 71.6753C98.1957 72.166 99.929 72.8971 100.299 73.2669C100.675 73.6432 102.046 74.6732 100.627 74.2678",
    stroke: "url(#paint8_linear_213_16515)",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8302 3.67891C25.7359 3.66842 25.3578 3.45778 25.5349 3.56405C25.7405 3.6874 25.7708 4.01391 25.9123 4.19577C26.6227 5.1092 26.9544 6.19959 27.75 7.08364C28.5657 7.98994 29.3483 8.96358 30.1128 9.91409C31.1713 11.23 32.5972 12.2506 33.8047 13.4255C37.1555 16.6858 40.1413 20.2797 42.8211 24.1319C44.5968 26.6845 46.9725 28.7793 48.9824 31.1465C50.0101 32.3569 51.0536 33.7778 52.2641 34.8056C53.5547 35.9014 54.5447 37.2925 55.8411 38.3826C58.6486 40.7435 61.0658 43.7424 63.5613 46.4227C64.8822 47.8415 66.1522 49.4621 67.7044 50.6397C69.517 52.0148 71.3252 53.4408 72.9961 54.9879C73.996 55.9137 74.7741 57.0104 75.7117 57.9906C76.7012 59.0251 77.7688 60.1518 78.6652 61.2723C79.73 62.6033 81.3334 63.3742 82.6114 64.4555C85.4857 66.8876 88.6472 69.3425 90.8074 72.4628C91.6251 73.6439 92.5217 74.8369 93.3999 75.966C94.0806 76.8412 95.3445 77.3288 96.2057 78.0335C97.1836 78.8335 97.8402 79.8053 98.8147 80.585C99.3695 81.0288 100.141 81.2974 100.406 82.0945",
    stroke: "url(#paint9_linear_213_16515)",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2988 2.6001C20.1895 2.6001 22.694 5.55808 22.8437 5.71361C23.4758 6.36996 24.1576 7.1053 24.7143 7.81388C26.1701 9.66672 27.6976 11.4535 29.3743 13.1302C30.1865 13.9424 30.9987 14.7546 31.8109 15.5668C32.6849 16.4408 33.4431 17.652 34.3952 18.4137C35.9272 19.6393 37.3486 21.0635 38.563 22.5814C41.8189 26.6514 46.0421 29.7893 48.728 34.3216C49.4175 35.4852 50.2537 36.5786 51.0826 37.6443C51.869 38.6554 52.2869 39.8859 53.0351 40.8932C53.8573 41.9999 54.6588 43.1246 55.5128 44.2159C56.4212 45.3766 57.5988 46.3514 58.4663 47.5386C59.8784 49.4708 62.0933 50.8198 63.7088 52.5595C64.5107 53.4231 65.5008 54.3258 66.4408 55.0372C67.5888 55.9059 68.6084 56.9101 69.6814 57.8758C71.8551 59.8321 74.4581 61.3625 76.7452 63.1921C79.1564 65.1211 81.3651 67.2942 83.7516 69.2468C84.746 70.0604 85.6363 70.977 86.6395 71.7573C87.5714 72.4821 88.555 73.1552 89.47 73.8986C90.9565 75.1064 91.788 76.9875 93.3177 78.1894C94.6898 79.2675 95.8916 80.6345 97.305 81.6844C97.9315 82.1498 100.111 83.9252 100.111 84.7527",
    stroke: "url(#paint10_linear_213_16515)",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7988 3.1001C15.2304 3.1001 17.8395 5.48215 18.0358 5.74643C18.5262 6.40663 18.9724 7.15889 19.5536 7.74004C20.719 8.90547 21.8765 10.6813 23.3193 11.5058C24.444 12.1485 25.4374 13.2195 26.2728 14.1967C27.4534 15.5778 28.741 16.8816 29.8827 18.2988C32.0447 20.9828 34.0994 23.7642 36.3065 26.4128C38.3377 28.8502 40.2144 31.4345 42.1069 33.9852C44.1663 36.7609 46.6608 39.2163 48.9 41.8448C51.2291 44.5791 53.6188 47.2501 55.8735 50.049C57.0447 51.5029 58.2734 52.8993 59.467 54.3316C60.5558 55.6383 61.8058 56.7011 62.9619 57.9497C64.1571 59.2404 65.5567 60.3243 66.7277 61.6416C67.743 62.7838 68.8571 63.6545 69.9519 64.7017C70.9387 65.6456 72.1152 66.3744 73.0859 67.3271C74.0303 68.254 74.9189 69.2617 75.9081 70.1411C77.9668 71.971 79.9135 73.9337 82.0941 75.6297C83.9749 77.0925 85.4796 78.9168 87.1479 80.585C87.8574 81.2945 88.7673 81.8883 89.5599 82.5048C90.3452 83.1156 90.9416 83.8751 91.7668 84.4492C93.1566 85.416 94.3476 86.7248 95.6802 87.7719C96.5974 88.4926 97.6131 89.0969 98.4861 89.9214C98.9594 90.3684 98.7829 90.1991 99.2984 90.6001C99.5549 90.7996 100.038 91.4021 100.298 91.6001C100.685 91.8938 100.51 91.6207 100.798 92.1001",
    stroke: "url(#paint11_linear_213_16515)",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79883 3.1001C10.2988 3.6001 10.5209 4.41149 10.7982 4.80566C11.2523 5.45086 11.833 5.98963 12.3078 6.61058C13.8311 8.60254 15.2423 10.8959 16.9678 12.6981C18.0666 13.8458 18.7965 15.3181 19.8064 16.5376C21.0581 18.0491 22.0199 19.7604 23.1702 21.3453C24.09 22.6126 25.2886 23.6938 26.2713 24.9223C27.1765 26.0538 28.0252 27.2344 28.9623 28.3517C31.3231 31.1664 33.3373 34.2678 35.46 37.2614C36.4339 38.6348 37.5458 39.9604 38.5612 41.3143C39.5503 42.6331 40.4943 44.1334 41.6624 45.3015C43.7882 47.4273 46.0238 49.5032 47.9796 51.7992C50.1574 54.3558 52.2547 56.9673 55.027 58.8959C57.445 60.5779 59.3658 63.009 61.5247 65.008C63.5088 66.8451 65.5513 68.8028 67.7271 70.4145C68.9968 71.3551 70.1035 72.5126 71.3369 73.4993C72.3575 74.3158 73.4507 74.9817 74.4381 75.8703C75.3836 76.7213 76.4513 77.379 77.3998 78.2413C78.4325 79.1801 79.5478 80.0278 80.5667 80.9651C82.5277 82.7693 84.6224 84.4485 86.6213 86.2076C87.6003 87.0691 88.53 87.9918 89.501 88.8658C90.5029 89.7674 91.432 90.895 92.5366 91.6634C94.2949 92.8866 95.6165 94.518 97.2458 95.8639C97.8326 96.3487 98.5 96.8228 99.0343 97.3571C99.2566 97.5795 100.845 98.6001 100.299 98.6001",
    stroke: "url(#paint12_linear_213_16515)",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79883 5.6001C4.77143 5.84671 6.15926 7.19952 6.55802 7.51853C6.90743 7.79806 7.07468 8.19243 7.30461 8.56867C7.82434 9.41914 8.41832 10.227 8.92903 11.0627C9.44058 11.8998 10.377 12.386 10.9883 13.1384C11.4027 13.6485 11.7689 14.0179 12.0302 14.6152C12.4593 15.5959 12.8281 16.5566 13.6546 17.2651C14.8298 18.2724 15.4471 19.7303 16.5261 20.8093C17.9224 22.2056 18.8993 23.9048 19.9965 25.5267C21.9246 28.377 24.5496 30.8326 26.2399 33.8376C27.2012 35.5467 28.0099 37.3864 29.2262 38.9406C30.4137 40.4579 31.524 42.1087 32.6227 43.699C33.1345 44.4397 33.7411 45.1663 34.3292 45.8485C35.0195 46.6492 35.4992 47.5829 36.1669 48.3918C37.4314 49.9238 38.6477 51.5201 39.826 53.1174C41.8869 55.9111 44.4349 58.2944 47.0621 60.534C49.805 62.8722 52.6438 64.9435 55.5862 67.0317C58.8767 69.3669 61.7477 72.4346 65.1769 74.5631C66.826 75.5867 68.2845 76.9201 69.6892 78.2468C71.0267 79.51 72.5056 80.7302 73.7421 82.0946C76.0732 84.6669 78.6537 86.8528 81.2079 89.1748C83.1725 90.9608 85.714 91.972 87.6728 93.7281C88.5081 94.477 89.5952 95.0574 90.5443 95.6479C91.4727 96.2256 92.3 96.9155 93.1696 97.5677C94.0082 98.1967 94.7119 98.9836 95.5324 99.6351C96.0674 100.06 96.5448 100.724 97.1568 101.03C97.7698 101.336 98.4164 101.961 98.8961 102.441C99.4347 102.98 99.2985 102.6 100.298 103.6",
    stroke: "url(#paint13_linear_213_16515)",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97405 10.6196C3.08408 10.7185 4.69801 12.6873 4.8683 13.0563C5.2479 13.8787 6.07571 14.5348 6.6322 15.2304C7.37275 16.1561 8.19108 17.0928 8.84733 18.0772C10.4263 20.4456 12.1329 22.7801 13.7945 25.0918C14.7032 26.3562 15.5212 27.7071 16.5265 28.8986C17.5564 30.1192 18.5451 31.2921 19.4061 32.6397C21.3579 35.6946 22.9825 38.9263 25.0178 41.935C26.9654 44.8141 28.7652 47.7998 30.7771 50.6314C32.7165 53.3609 34.6895 56.076 36.9713 58.5403C38.1604 59.8246 39.3099 61.1566 40.4499 62.4865C41.5429 63.7617 42.7786 64.8538 43.9202 66.0799C46.2719 68.6057 48.6869 71.2712 51.5583 73.234C54.5527 75.2808 57.1988 77.8464 60.1235 79.9942C61.5276 81.0254 63.1201 81.7084 64.5209 82.759C66.0193 83.8828 67.6635 84.7642 69.2466 85.7536C72.3829 87.7138 75.536 89.6315 78.5829 91.7262C82.2099 94.2198 85.7278 97.0391 88.8874 100.111C90.6921 101.866 92.8222 103.261 94.6467 104.984C95.552 105.839 96.5314 106.492 97.5182 107.232C97.6177 107.307 98.6585 108.1 99.0031 108.52C100.299 110.1 99.7988 108.6 100.299 109.6",
    stroke: "url(#paint14_linear_213_16515)",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29883 25.1001C3.64256 24.3618 5.61276 27.1469 5.73067 27.4712C6.0774 28.4247 6.53351 29.3574 7.20117 30.1204C9.2554 32.4681 11.2327 34.8846 13.2933 37.2395C17.363 41.8906 21.8175 46.2562 25.2674 51.431C26.2035 52.8353 27.2715 54.1275 28.2084 55.4808C29.0032 56.6289 30.147 57.5599 30.986 58.6785C32.6367 60.8795 33.8458 63.3093 35.8176 65.3541C37.6087 67.2115 39.4018 69.0564 41.1861 70.9094C43.3392 73.1452 44.8108 75.8781 47.0682 78.0518C47.944 78.8952 49.1926 79.8238 50.2542 80.421C51.3791 81.0537 52.6754 81.37 53.7321 82.1015C54.8674 82.8875 56.087 83.4308 57.315 84.0039C58.8226 84.7074 60.1263 85.7713 61.6098 86.513C65.177 88.2967 68.4058 89.8428 71.2731 92.7102C73.7547 95.1917 75.736 98.0134 78.2055 100.483C79.3292 101.607 80.4407 102.718 81.5666 103.844C82.5462 104.824 83.6211 105.387 84.7177 106.201C87.3696 108.171 89.79 110.387 92.1169 112.714C93.864 114.461 95.6493 116.153 97.3687 117.872C97.9545 118.458 98.752 119.158 99.4227 119.553C99.6515 119.687 100.399 120.44 100.263 120.44",
    stroke: "url(#paint15_linear_213_16515)",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62981 33.0497C2.85266 33.0497 3.49458 32.9332 3.83988 33.3648C4.48781 34.1747 5.16323 34.9927 5.7422 35.8974C6.68185 37.3656 7.42138 38.942 8.67153 40.1922C9.82245 41.3431 11.0295 42.5866 12.0327 43.8684C14.0517 46.4482 16.456 48.4067 18.7083 50.7424C19.7836 51.8576 20.5704 53.2877 21.4859 54.5237C22.2653 55.5759 23.2472 56.4612 23.9601 57.5814C24.7238 58.7815 25.7922 59.8255 26.6327 60.9893C27.4482 62.1184 28.3568 63.1969 29.1419 64.3388C30.7221 66.6373 32.6623 68.7043 34.3003 70.9794C36.2545 73.6935 38.7026 75.8931 40.8125 78.4719C42.7472 80.8365 44.7651 83.1659 47.068 85.1475C48.5936 86.4603 49.5225 88.5264 50.8376 90.0492C53.7777 93.4536 57.321 96.4379 60.1275 99.9459C61.2882 101.397 62.978 102.36 64.2355 103.727C65.2091 104.786 66.7674 105.554 68.0168 106.26C69.3454 107.011 70.1333 108.363 71.483 109.096C72.6016 109.703 74.0157 110.7 74.8442 111.663C75.8905 112.879 77.4306 113.778 78.7889 114.604C80.0247 115.357 81.1214 116.289 82.3601 117.032C84.565 118.355 86.7632 119.789 88.919 121.175C91.0563 122.549 92.806 124.957 94.6026 126.753C95.794 127.945 97.0592 129.388 98.5823 130.15C99.2589 130.488 99.2637 130.565 99.7988 131.1C100.038 131.339 99.7988 131.1 100.799 132.1",
    stroke: "url(#paint16_linear_213_16515)",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05021 45.0238C3.88246 44.8141 3.58781 43.5767 4.16692 43.5767C4.59367 43.5767 5.27616 44.6352 5.62575 44.9071C6.56262 45.6358 7.05819 46.5316 7.7148 47.5447C8.53258 48.8064 9.50586 49.9135 10.399 51.1159C12.4257 53.8441 13.527 57.465 15.9193 59.8572C17.1568 61.0947 17.5863 63.2039 18.5452 64.6422C19.3058 65.7832 20.4953 66.5337 21.2761 67.6182C23.5915 70.8341 26.1273 73.4365 29.2122 75.9044C32.3605 78.4231 35.4798 81.4008 37.8835 84.6457C40.3753 88.0097 43.0029 91.1948 45.4811 94.5541C47.6063 97.435 50.51 99.4664 52.997 101.953C55.8035 104.76 58.5587 107.499 61.3998 110.251C64.0094 112.779 66.3001 115.607 69.1258 117.919C70.3775 118.943 71.6212 120 72.8371 121.07C74.1905 122.261 75.2171 123.962 76.7467 124.956C79.701 126.876 81.6607 129.848 84.4027 131.994C85.3545 132.738 85.9659 133.707 86.8185 134.514C87.7845 135.43 88.9891 136.106 89.9696 137.035C91.3041 138.3 92.6898 139.747 94.2878 140.618C94.7822 140.888 95.9305 141.576 96.2251 142.077C96.4758 142.503 97.4676 142.824 97.9057 143.127C98.5921 143.603 99.1895 144.122 99.843 144.645C100.639 145.281 99.1729 144.1 100.263 145.438",
    stroke: "url(#paint17_linear_213_16515)",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68018 58.8887C4.74643 58.3587 5.90768 59.9424 6.03397 60.1491C6.67604 61.1998 7.28464 62.2529 7.92462 63.3002C9.14711 65.3006 10.7912 67.0123 12.2428 68.8671C13.9843 71.0924 15.5508 73.4653 17.2845 75.6944C19.1602 78.106 21.4595 80.1284 23.3649 82.5101C24.2949 83.6726 25.3304 84.5581 26.3643 85.6145C27.6387 86.9166 28.6251 88.4406 29.9355 89.7226C32.7853 92.5104 35.3729 95.7236 37.9649 98.7556C40.606 101.845 43.587 104.781 46.4845 107.625C47.7855 108.903 49.2266 109.976 50.5225 111.243C51.2887 111.992 52.2155 112.539 52.9734 113.297C53.6185 113.942 54.1464 114.651 54.934 115.141C61.1257 118.994 66.26 124.656 71.5881 129.59C76.4622 134.103 81.6603 138.163 86.83 142.299C88.3733 143.534 89.9767 144.541 91.3932 145.905C92.6567 147.122 93.7907 148.373 95.0578 149.593C95.8151 150.322 96.7988 150.1 98.1622 151.53C100.299 153.1 99.2988 152.6 100.299 152.6",
    stroke: "url(#paint18_linear_213_16515)",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05009 65.821C3.09412 65.9405 4.03595 66.2014 4.72699 66.9181C6.54296 68.8013 7.63363 71.3913 9.30189 73.4303C10.122 74.4327 11.1129 75.4048 12.0328 76.3246C12.9717 77.2635 13.8267 78.5774 14.9738 79.2656C15.7757 79.7468 16.4155 80.8374 16.8645 81.6231C17.726 83.1307 18.4719 84.5778 19.4904 85.9879C20.2524 87.043 21.391 87.8951 22.2213 88.9406C23.3242 90.3294 24.3869 91.7215 25.5941 93.0254C27.615 95.2079 29.3227 97.714 31.6162 99.6426C32.7934 100.633 33.6053 101.958 34.6739 103.05C35.6807 104.08 36.8063 104.973 37.825 105.991C40.0905 108.257 42.5584 110.174 44.8974 112.352C49.7581 116.877 53.824 122.327 58.9839 126.532C61.8953 128.904 64.0809 132.124 66.955 134.503C68.4649 135.753 69.6392 137.189 70.9697 138.611C72.3804 140.119 73.9148 141.518 75.2645 143.081C76.9658 145.051 79.3099 146.257 81.1932 148.006C82.5536 149.269 84.2554 150.179 85.7797 151.227C86.7273 151.878 87.852 153.061 88.9308 153.421C90.2432 153.858 98.2217 161.241 99.2988 161.6",
    stroke: "url(#paint19_linear_213_16515)",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29883 75.1001C4.79883 75.7584 4.32076 74.893 4.63377 75.4843C4.93866 76.0601 5.5345 76.6423 5.94089 77.1648C7.5166 79.1907 9.06504 81.348 10.7725 83.2452C12.873 85.5791 14.8457 87.9529 16.8646 90.3527C19.1481 93.067 21.6789 95.6252 23.8437 98.4288C26.2655 101.565 28.8714 104.297 31.6747 107.1C33.3334 108.759 34.9742 110.379 36.4013 112.247C37.5148 113.705 38.982 114.766 40.1709 116.133C44.9206 121.595 49.8766 126.772 54.9927 131.889C59.4993 136.395 64.0569 140.977 68.9624 145.065C71.3255 147.034 73.8598 148.773 76.42 150.48C77.5292 151.219 78.497 152.184 79.6761 152.791C80.7014 153.318 81.8228 154.166 82.6171 154.996C84.1575 156.607 86.0286 157.992 87.8222 159.303C88.8508 160.055 89.5015 161.434 90.5999 162.081C91.4363 162.573 91.9191 163.599 92.7006 164.088C93.0013 164.276 93.2495 164.743 93.3425 165.068C93.4526 165.454 93.9774 165.406 93.3308 164.975",
    stroke: "url(#paint20_linear_213_16515)",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68034 82.2065C4.26414 82.1545 4.52758 81.4257 4.68034 81.693C4.91304 82.1003 5.14651 82.5808 5.42726 82.9418C5.95461 83.6198 6.25584 84.3889 6.67602 85.1359C7.20221 86.0713 8.04163 86.91 8.6717 87.7851C10.0231 89.662 11.2661 91.5132 13.0832 92.9669C14.1806 93.8448 14.8889 95.1985 15.7675 96.2813C16.3762 97.0316 16.9615 97.819 17.5414 98.5921C19.0319 100.579 19.9755 102.938 21.8012 104.684C23.926 106.717 25.9192 108.869 28.08 110.87C30.6508 113.25 33.2453 115.819 35.4442 118.549C37.5533 121.167 39.7842 123.623 41.653 126.427C43.356 128.981 45.4611 131.394 47.2782 133.884C49.0687 136.338 51.0652 138.724 52.9969 141.073C53.9522 142.235 55.2004 143.12 56.1479 144.283C56.971 145.293 57.7406 146.31 58.7738 147.119C60.9934 148.856 62.666 151.127 64.7609 152.989C66.3585 154.409 67.9264 156.033 69.5926 157.366C70.7053 158.256 72.1126 159.366 72.9537 160.517C73.6312 161.444 74.8764 162.066 75.6846 162.874C76.0556 163.245 76.6244 163.344 76.9451 163.761C77.3449 164.281 77.8897 164.791 78.4156 165.185",
    stroke: "url(#paint21_linear_213_16515)",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79883 91.6001C3.54643 91.5685 4.33815 91.9342 4.84373 92.29C6.44619 93.4176 7.60874 95.4221 8.6717 97.0166C9.72761 98.6005 10.9414 100.367 12.2429 101.743C13.9655 103.565 15.116 105.843 16.7595 107.73C20.3977 111.907 23.6068 116.535 26.9946 120.906C30.7113 125.702 34.4528 130.686 38.5019 135.191C45.4012 142.868 52.5641 150.278 59.089 158.253C60.4406 159.905 61.5746 161.578 63.0803 163.084C63.6836 163.687 64.2705 164.274 64.8659 164.87C65.8461 165.85 64.9388 164.6 64.5508 164.135",
    stroke: "url(#paint22_linear_213_16515)",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26025 101.743C3.87634 102.175 4.75262 102.098 5.32228 102.49C6.91601 103.586 8.15573 105.568 9.2903 107.1C12.137 110.943 14.7699 114.97 17.7048 118.759C21.1716 123.234 24.5793 127.777 28.1034 132.215C29.8541 134.42 31.3785 136.82 33.2502 138.926C34.6439 140.494 35.7624 142.278 37.2415 143.758C40.0797 146.596 42.4423 149.687 45.0142 152.744C46.0717 154.001 46.6123 155.659 47.6518 156.887C48.5361 157.932 49.3922 159.059 50.3594 160.026C51.2888 160.956 51.937 162.127 52.7402 163.131C52.947 163.389 53.2803 163.823 53.4638 164.135C53.6635 164.474 54.2574 165.205 54.2574 165.185",
    stroke: "url(#paint23_linear_213_16515)",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47032 109.306C4.37111 109.32 5.36559 110.74 5.52068 110.94C6.55111 112.265 7.53884 113.565 8.50837 114.931C9.5303 116.371 10.4066 117.915 11.4494 119.343C12.6871 121.038 14.1227 122.61 15.184 124.443C17.7256 128.833 21.2133 132.648 23.7969 137.035C24.7278 138.616 25.4169 140.426 26.5746 141.867C27.9124 143.532 29.3699 145.088 30.5076 146.909C33.2007 151.218 36.5473 155.237 38.9221 159.723C39.5728 160.952 40.6748 161.91 41.2329 163.166C41.4888 163.742 42.3884 164.712 42.9135 164.975",
    stroke: "url(#paint24_linear_213_16515)",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89048 118.759C4.19795 118.136 4.27869 118.648 4.72709 119.132C5.51504 119.983 6.15868 120.999 6.82781 121.957C7.98792 123.618 9.04967 125.297 10.1423 126.999C11.2086 128.659 12.5432 130.322 13.3984 132.099C15.0992 135.631 17.907 138.54 19.7939 141.96C21.4562 144.973 23.527 147.68 25.2675 150.643C26.3324 152.457 27.6262 154.137 28.6286 155.942C29.5334 157.57 31.024 158.968 31.7797 160.668C32.109 161.409 33.4989 163.113 34.1838 163.504C34.7277 163.815 35.1176 164.555 35.4443 165.068C35.9381 165.844 35.2001 164.431 35.1408 164.135",
    stroke: "url(#paint25_linear_213_16515)",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89012 125.691C4.34963 125.691 4.21907 125.795 4.77341 126.112C5.11646 126.308 5.67166 127.395 5.84711 127.71C7.28611 130.301 9.09965 132.704 10.7721 135.145C12.5508 137.741 14.2684 140.17 15.8139 142.917C17.0267 145.073 18.3503 147.161 19.6418 149.266C20.2524 150.261 20.8031 151.306 21.4858 152.254C22.1817 153.22 23.1583 154.035 23.6916 155.101C24.0969 155.912 24.653 156.604 25.057 157.412C25.4586 158.215 25.8644 159.14 26.3175 159.886C26.9251 160.887 27.7357 161.916 28.2081 162.979C28.4228 163.462 28.6951 163.95 29.0484 164.345C29.2698 164.592 29.4685 165.438 29.4685 164.765",
    stroke: "url(#paint26_linear_213_16515)",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31022 133.884C5.31022 134.167 5.0433 134.396 5.21685 134.62C5.60384 135.117 5.83021 135.687 6.19719 136.195C7.52857 138.039 8.7843 139.94 9.97848 141.867C11.3988 144.159 13.297 146.117 14.7635 148.379C16.0331 150.338 17.155 152.385 18.4981 154.308C19.4719 155.702 20.0802 157.375 20.8555 158.883C21.343 159.831 21.9916 160.673 22.4894 161.614C22.953 162.489 23.6657 163.261 24.2167 164.088C24.4829 164.487 24.4105 164.095 25.2988 165.1",
    stroke: "url(#paint27_linear_213_16515)",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31066 142.707C5.31066 143.43 4.31037 142.689 4.79715 143.454C5.56754 144.665 6.59429 145.716 7.41138 146.909C9.91042 150.556 13.338 153.418 15.9193 156.992C16.8154 158.233 17.7253 159.425 18.5452 160.727C19.0226 161.485 19.261 162.143 19.899 162.781C20.455 163.337 20.518 164.183 21.1127 164.718C21.4044 164.981 22.3572 165.966 21.6963 164.975",
    stroke: "url(#paint28_linear_213_16515)",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10059 150.27C5.10059 152.034 6.92982 153.174 7.81985 154.565C8.78156 156.067 9.94152 157.422 11.2043 158.684C12.6479 160.128 13.7105 161.326 14.7172 163.084C15.2988 164.1 14.7988 163.6 15.7988 165.1",
    stroke: "url(#paint29_linear_213_16515)",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73047 157.412C6.44232 157.412 6.75001 158.69 7.15429 159.14C8.12036 160.213 8.91118 161.428 9.82687 162.547C10.5779 163.465 10.5147 163.595 12.2988 165.1",
    stroke: "url(#paint30_linear_213_16515)",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7988 3.10019C13.2446 3.03036 12.342 4.42259 11.8371 4.93145C11.0013 5.77403 9.87497 6.51475 8.90497 7.19168C7.96711 7.84617 6.90638 8.42238 6.05903 9.19111C5.36662 9.81928 3.98926 10.6175 3.98926 11.6252",
    stroke: "url(#paint31_linear_213_16515)",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5124 2.41034C19.4409 1.8335 17.323 4.09574 17.1743 4.24557C15.4652 5.96837 13.582 7.3987 11.6166 8.80466C10.1064 9.88502 8.0951 10.9527 6.83506 12.3206C5.75358 13.4946 5.04632 14.921 3.47168 15.4501",
    stroke: "url(#paint32_linear_213_16515)",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7892 2.23638C22.3713 2.18373 22.5515 2.09539 22.1759 2.4199C21.3923 3.097 20.7588 4.08983 20.0199 4.83467C17.5679 7.30636 14.7496 9.6283 12.0954 11.8858C9.88047 13.7696 7.3328 15.4044 5.33027 17.4977C4.70234 18.1541 3.99442 18.7315 3.29883 19.3136",
    stroke: "url(#paint33_linear_213_16515)",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1781 2.49731C26.1988 3.76644 25.0572 4.99421 23.9968 6.19674C22.4279 7.97584 20.4548 9.17048 18.5732 10.582C16.9406 11.8066 15.5249 13.2718 13.8204 14.407C12.4974 15.2881 11.3455 16.4173 10.0354 17.2757C8.88541 18.0292 5.80458 20.2777 4.80859 21.2274",
    stroke: "url(#paint34_linear_213_16515)",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4483 2.58426C32.0088 2.19048 31.3739 3.16495 31.0684 3.47289C29.6288 4.92405 28.2351 6.45842 26.6702 7.7905C24.813 9.37133 22.7073 10.7017 20.9016 12.3303C19.221 13.846 17.5659 15.4202 15.8039 16.8411C12.8944 19.1873 10.0131 21.525 6.92108 23.6217C6.0466 24.2147 5.32007 24.9167 4.50635 25.5729",
    stroke: "url(#paint35_linear_213_16515)",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5883 2.41034C36.6417 1.87245 36.6214 2.12388 36.205 2.48761C34.3693 4.09131 32.7705 6.08488 31.0497 7.81943C28.9952 9.89048 26.6985 11.5025 24.5146 13.4024C20.7276 16.6968 17.0647 20.0271 12.9967 22.9649C10.743 24.5924 8.42109 26.1305 6.23163 27.833C5.74703 28.2099 5.39806 28.7125 4.85178 29.0114C4.54143 29.1813 4.07523 29.3759 3.81689 29.6103",
    stroke: "url(#paint36_linear_213_16515)",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6599 4.39034C39.8122 3.21622 41.0539 2.31684 39.6002 4.13177C36.6652 7.79605 32.4741 10.8279 28.9211 13.8998C25.1438 17.1657 21.2191 20.2732 17.3769 23.4668C13.6286 26.5822 8.80535 28.7229 5.29883 32.1001",
    stroke: "url(#paint37_linear_213_16515)",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2988 4.1001C41.8958 6.49548 39.5875 8.98779 37.1687 11.3721C34.6328 13.8719 31.7177 15.9112 28.9988 18.1999C26.6394 20.186 24.4916 22.4046 22.0172 24.2545C19.441 26.1805 6.81347 35.0948 4.29883 37.1001",
    stroke: "url(#paint38_linear_213_16515)",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2906 4.16821C47.4291 7.35109 44.0781 10.2386 40.7275 12.8807C37.2987 15.5844 33.9176 18.3179 30.5511 21.1006C27.6795 23.4742 24.961 26.0419 22.09 28.4028C20.012 30.1116 17.8886 31.7768 15.8519 33.5318C14.9014 34.3509 14.0515 35.3136 12.9676 35.9562C12.0307 36.5118 11.1545 37.0663 10.275 37.7045C9.14869 38.522 8.10915 39.4648 6.78707 39.9261C6.1289 40.1558 4.50245 41.4843 4.29883 42.1",
    stroke: "url(#paint39_linear_213_16515)",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5259 4.14889C54.5681 3.80802 54.8577 3.89164 54.5642 4.18753C54.3592 4.39412 54.1764 4.70343 53.9318 4.84434C53.3339 5.18871 52.6861 6.00335 52.1974 6.49605C51.9438 6.7516 51.3264 7.12773 50.99 7.27843C50.5203 7.48886 50.3241 8.03066 49.9072 8.32161C49.09 8.89191 48.2953 9.34876 47.6266 10.0602C46.6235 11.1276 45.4441 11.7572 44.2632 12.5813C42.9729 13.4817 41.6686 14.5231 40.4686 15.5466C37.7013 17.9069 34.761 20.1881 32.1416 22.7136C30.4954 24.3009 28.4313 25.667 26.5839 27.0119C24.7215 28.3678 23.1098 30.242 21.3999 31.7932C18.7256 34.2193 15.6901 36.2645 13.0921 38.7864C12.4611 39.3988 10.8945 40.1242 10.5432 40.921C10.0988 41.9289 8.90919 42.1334 8.21469 42.8335C7.47023 43.5839 7.02113 44.2126 6.05868 44.6977C5.00135 45.2306 4.75247 45.8029 4.50635 46.9193",
    stroke: "url(#paint40_linear_213_16515)",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2176 3.80131C60.1697 3.41566 59.4021 4.27562 59.2689 4.40984C58.3399 5.34634 57.3095 6.12453 56.3463 7.01779C53.4052 9.74532 50.2866 12.5049 47.0228 14.832C45.2432 16.1008 43.5211 17.448 41.8004 18.7922C39.8039 20.3519 38.0092 22.271 35.8977 23.6604C31.9638 26.2489 28.4359 29.4936 24.6865 32.3149C21.7285 34.5407 19.1204 37.2341 16.1487 39.453C14.7163 40.5225 13.579 41.8832 12.2678 43.0848C11.3554 43.9209 10.3914 44.6382 9.50813 45.5285C8.51756 46.527 7.10849 48.186 5.88603 48.8706C5.37504 49.1567 5.01351 49.4262 4.67866 49.9138C4.1538 50.678 3.7151 50.6484 3.98874 51.6138",
    stroke: "url(#paint41_linear_213_16515)",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5298 3.97512C64.4438 3.28208 62.9444 5.13112 62.8433 5.2308C61.5945 6.46164 60.1858 7.6767 58.8379 8.80466C57.2812 10.1074 55.675 11.382 54.2192 12.8035C52.3273 14.651 50.0596 16.0509 48.1441 17.8745C47.196 18.7771 46.0744 19.3656 45.0394 20.1444C44.0107 20.9185 43.1056 21.8451 42.1072 22.6558C40.0908 24.2931 38.0832 26.0276 35.9075 27.4467C34.8359 28.1456 33.9946 29.1546 32.9274 29.8808C31.8564 30.6095 30.8282 31.3874 29.7748 32.141C27.7029 33.6232 25.7389 35.205 23.7859 36.8353C21.1692 39.0196 18.1584 40.7006 15.7176 43.0944C14.0083 44.7709 11.9832 45.8311 10.4569 47.7114C9.56417 48.8114 8.15852 49.497 7.1798 50.4836C6.66494 51.0026 5.97634 51.3683 5.46458 51.8842C5.00168 52.3508 4.32727 53.0674 3.79883 53.6001",
    stroke: "url(#paint42_linear_213_16515)",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5319 3.9751C69.8772 4.14915 68.9042 4.43398 68.6311 4.70919C68.3032 5.03972 67.9103 5.29984 67.6346 5.6751C66.3418 7.43432 64.6051 9.11526 63.0734 10.6592C60.964 12.7855 58.6146 14.5216 56.4233 16.5319C53.9725 18.7803 51.6306 21.1371 49.0066 23.187C43.6681 27.3576 38.685 31.9668 33.3492 36.1398C28.9984 39.5425 24.6479 43.0329 20.0298 46.05C16.1978 48.5537 12.1569 50.6827 8.90478 53.9608C8.30111 54.5693 7.45913 55.6977 6.74877 56.0955C6.09336 56.4625 5.49238 56.8489 4.85147 57.2642C4.55351 57.4573 3.17494 58.1214 4.16155 57.8728",
    stroke: "url(#paint43_linear_213_16515)",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36897 62.9147C4.60422 62.0475 8.91233 59.6718 9.50852 59.2636C12.4739 57.2332 15.4518 55.192 18.3051 53.0045C22.1543 50.0535 26.0611 47.1594 29.8613 44.1375C30.8483 43.3526 31.7413 42.6095 32.6306 41.7131C33.6735 40.6618 34.9748 39.9157 36.0706 38.9216C38.3455 36.8578 40.6349 34.5929 43.1519 32.8364C45.79 30.9953 48.0385 28.6792 50.5973 26.7511C52.9893 24.9489 55.3847 23.0901 57.7074 21.1972C61.6622 17.974 65.8256 15.0047 69.8673 11.8955C72.4371 9.91863 75.1011 8.10747 77.5427 5.97446C78.0071 5.56875 80.9397 3.50185 80.7432 3.10571",
    stroke: "url(#paint44_linear_213_16515)",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54147 68.1307C4.53168 68.09 4.8294 68.0124 5.40732 67.6091C6.18438 67.0668 6.84959 66.3647 7.64957 65.8704C9.73166 64.5841 11.3471 62.5284 13.2648 61.0023C15.8167 58.9714 18.3684 56.952 20.9881 55.004C23.8032 52.9106 26.4061 50.5546 29.181 48.4068C31.9004 46.302 34.7589 44.3669 37.3163 42.0512C39.869 39.7397 42.6941 37.5478 45.4229 35.4443C48.2504 33.2648 51.1456 31.1492 54.0087 29.0114C58.6814 25.5224 63.0735 21.6089 67.8167 18.2222C68.9369 17.4224 69.9741 16.5248 71.046 15.6626C72.0812 14.8298 73.2715 14.2428 74.3423 13.4603C76.0705 12.1973 77.94 11.238 79.7083 10.0603C81.9154 8.59039 83.742 6.70745 86.0039 5.35631C86.6329 4.98057 87.3512 4.14656 88.0737 3.98472C88.7238 3.8391 89.4656 3.55347 89.7122 2.93188",
    stroke: "url(#paint45_linear_213_16515)",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29883 74.1002C4.29883 73.4309 6.11299 72.1383 6.57614 71.7433C8.33583 70.2424 10.1116 68.8073 11.8368 67.2615C16.338 63.2284 21.4323 59.9866 26.1336 56.2115C28.5362 54.2822 30.7859 52.239 33.4065 50.5706C36.1678 48.8127 38.811 46.8482 41.4173 44.8718C46.5706 40.9639 51.962 37.4113 57.1131 33.4934C59.724 31.5075 62.4999 29.7004 65.0089 27.582C67.8915 25.1481 70.983 23.1211 73.9875 20.8496C78.0261 17.7964 81.799 14.2769 86.0037 11.4513C88.0386 10.0839 89.6811 8.29504 91.6093 6.79566C92.1459 6.37841 92.8175 5.89585 93.1616 5.28884C93.362 4.93545 94.0869 4.28171 93.3341 5.19225",
    stroke: "url(#paint46_linear_213_16515)",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29883 78.1001C3.60007 78.1001 5.45662 76.4338 5.7233 76.2154C7.06567 75.1159 8.43915 73.8749 9.68078 72.6512C11.7413 70.6203 14.1707 68.865 16.5034 67.1648C19.6341 64.8829 22.5061 62.3328 25.5586 59.9591C28.4538 57.7078 31.4638 55.6218 34.3456 53.3523C37.9104 50.545 41.3946 47.6588 45.0777 45.0069C51.45 40.4188 57.5319 35.4255 63.8398 30.7501C72.547 24.2964 81.5651 18.2134 90.5361 12.1467C92.5747 10.768 94.7712 9.11397 96.5058 7.36543C96.7181 7.15147 96.849 6.86666 97.1287 6.71827C97.6122 6.46175 98.1024 6.2135 98.5948 5.97452C98.8618 5.84496 99.1276 5.71212 99.371 5.53987C99.8444 5.20479 99.4726 5.30269 99.1985 5.19214",
    stroke: "url(#paint47_linear_213_16515)",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85123 81.3442C4.11448 81.27 4.50225 81.4256 4.88956 81.1704C5.94833 80.4726 7.00528 79.784 8.06129 79.0744C13.0422 75.7271 17.7368 72.0761 22.5401 68.4783C28.3838 64.1014 34.6118 60.2 40.3632 55.6994C46.9789 50.5223 53.6547 45.3504 60.5626 40.5733C66.6071 36.3932 72.6559 32.1964 78.5965 27.8716C82.7884 24.8198 87.1492 22.0082 91.2547 18.85C93.2873 17.2863 95.3182 15.7933 97.3011 14.1943C97.6495 13.9133 100.961 11.8366 100.751 11.625",
    stroke: "url(#paint48_linear_213_16515)",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90688 86.2273C4.56927 86.1845 5.32446 85.3584 5.45958 85.2212C6.38141 84.2854 7.59553 83.5024 8.68052 82.7834C10.6966 81.4474 12.5934 79.8276 14.5506 78.3915C17.3612 76.3293 20.3684 74.5453 23.0985 72.3743C25.702 70.304 28.424 68.2712 31.1604 66.3862C33.7068 64.6321 36.1024 62.6663 38.6886 60.9785C41.2304 59.3198 43.7734 57.6435 46.1501 55.745C49.036 53.4397 51.941 50.9907 54.9934 48.9249C60.6939 45.067 65.8104 40.3561 71.4602 36.4263C74.1135 34.5807 76.6572 32.609 79.3505 30.8155C80.6124 29.9751 81.737 28.9467 83.0384 28.1648C84.3546 27.3741 85.6942 26.6537 86.9835 25.8141C90.0955 23.7875 93.2553 21.897 96.1508 19.5454C97.9153 18.1124 99.9088 17.4889 101.821 16.2273",
    stroke: "url(#paint49_linear_213_16515)",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79883 91.1001C4.79883 91.3099 6.44118 89.7639 6.5753 89.7041C7.07189 89.4826 7.53613 89.0409 8.01486 88.7473C9.41423 87.889 10.8438 87.1396 12.2287 86.2501C13.9897 85.1189 15.6876 83.8075 17.3673 82.5568C18.3871 81.7974 19.3915 80.9307 20.4561 80.2413C21.6243 79.485 22.886 78.8664 23.974 77.9929C29.6215 73.4585 35.8532 69.8072 41.8208 65.7267C48.423 61.2122 55.3714 57.1926 61.8603 52.5037C64.7496 50.4158 67.664 48.3736 70.5644 46.3036C73.1088 44.4878 75.7967 42.8162 78.1912 40.7924C80.3746 38.9471 82.7194 37.1839 85.0649 35.5492C86.9141 34.2604 88.5968 32.7459 90.4704 31.4923C91.9074 30.5309 93.041 29.2574 94.5412 28.354C95.7274 27.6397 96.9522 26.9947 98.1449 26.2873C99.1574 25.6869 100.017 25.2698 100.852 24.4312",
    stroke: "url(#paint50_linear_213_16515)",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.406 20.4921C101.071 19.7269 98.8175 21.7479 97.982 22.3176C95.6947 23.8773 93.1737 25.0313 90.9198 26.6642C85.9668 30.2528 81.0575 34.0351 75.7032 37.0091C73.0846 38.4635 70.757 40.3642 68.229 41.9642C65.7157 43.555 63.5898 45.6973 61.2531 47.5375C57.0601 50.8395 52.5202 53.7172 48.4895 57.2159C46.3128 59.1053 44.0387 60.8483 41.504 62.2193C38.9377 63.6074 36.5433 65.6441 34.164 67.3483C30.2576 70.1461 26.1146 72.8058 21.7166 74.7761C18.1324 76.3818 14.9265 78.8047 11.6648 80.9965C8.98872 82.7949 5.14865 84.6449 3.81689 87.7772",
    stroke: "url(#paint51_linear_213_16515)",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50635 95.9489C4.50635 95.5428 4.92721 95.2387 5.28251 95.0796C6.51371 94.528 7.75036 93.0301 8.82796 92.2011C13.6465 88.4944 18.3812 84.6542 23.4888 81.3443C35.4813 73.5731 47.5105 65.8794 59.2882 57.7762C65.6555 53.3955 72.215 49.2822 78.6732 45.0455C83.4697 41.899 88.1178 38.4771 92.9508 35.4058C94.7309 34.2745 95.8479 32.5394 97.4736 31.3103C98.2692 30.7089 99.0332 30.0519 99.7542 29.3978C100.159 29.0303 101.274 28.8182 100.799 28.1001",
    stroke: "url(#paint52_linear_213_16515)",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79883 100.6C4.41367 100.552 6.95448 98.9112 7.1035 98.808C8.30857 97.9728 9.49918 97.1218 10.716 96.2966C15.4296 93.1002 19.6866 89.2942 24.3516 86.0387C27.3173 83.969 29.9704 81.4618 32.8703 79.2966C35.6604 77.2133 38.721 75.2992 41.6285 73.3853C47.1436 69.7546 52.6364 66.1139 57.9758 62.2387C60.5533 60.368 63.2297 58.6281 65.8333 56.791C68.3481 55.0165 70.7398 53.1087 73.3267 51.4398C78.3358 48.2083 82.9968 44.4026 87.9875 41.1433C90.6082 39.4318 92.8758 37.2421 95.5863 35.7052C96.5071 35.1831 97.4448 34.636 98.3364 34.0535C98.9114 33.6778 99.61 33.3587 100.138 32.9234C100.684 32.4728 100.638 32.5847 99.8887 32.8364",
    stroke: "url(#paint53_linear_213_16515)",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50635 105.859C5.17738 105.098 6.36108 104.852 7.22772 104.256C9.51766 102.68 11.9943 101.322 14.3282 99.7835C19.758 96.2048 24.6195 92.0104 29.6503 87.9125C35.4957 83.151 41.3314 78.5569 47.6266 74.3994C53.9724 70.2085 59.9974 65.5361 66.4654 61.5239C69.4185 59.692 72.3191 57.7028 75.2236 55.7864C77.9544 53.9846 80.8594 52.4057 83.5027 50.4739C86.2859 48.4399 89.4565 46.5294 91.9542 44.1375C93.4918 42.6652 95.2241 41.0117 97.1287 40.0517C98.3399 39.4413 99.1617 38.4248 100.233 37.7046",
    stroke: "url(#paint54_linear_213_16515)",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29883 111.286C4.41733 110.211 6.39005 109.667 7.1282 109.228C8.74244 108.266 10.3814 107.338 11.9996 106.376C17.0311 103.383 21.8971 99.9059 26.6632 96.5052C33.0409 91.9544 39.4867 87.4868 45.6568 82.6665C47.0891 81.5476 48.3591 80.2369 49.8148 79.1449C51.3803 77.9705 53.0696 77.029 54.5632 75.7472C55.9451 74.5613 57.5146 73.8052 58.9918 72.7712C60.4727 71.7345 61.8175 70.4815 63.2481 69.3735C64.764 68.1996 66.3299 67.1112 67.9474 66.0875C69.3351 65.2091 70.4696 64.0153 71.8347 63.1238C74.6167 61.3069 77.0779 59.0634 80.0276 57.4941C82.2821 56.2947 84.4424 54.6694 86.6212 53.3029C87.6235 52.6742 88.9094 51.8435 89.7704 51.0212C91.497 49.3725 93.6016 47.7561 95.749 46.7307C96.5111 46.3669 97.0373 45.8093 97.7419 45.3915C98.0259 45.2231 98.1719 45.1001 98.4185 44.7715C98.6467 44.6948 99.6719 44.4349 99.6719 44.1001",
    stroke: "url(#paint55_linear_213_16515)",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59033 114.804C7.4577 113.45 6.36704 114.092 6.48835 114.023C8.61985 112.814 10.5538 111.369 12.5776 109.993C18.9957 105.63 25.5107 101.477 31.8297 96.9477C33.1573 95.996 34.5728 95.183 35.9261 94.2692C37.665 93.0952 39.2209 91.6818 40.9698 90.5244C44.2025 88.3849 47.2195 85.9608 50.5404 83.9523C53.7074 82.0369 56.6048 79.6124 59.6682 77.529C62.5692 75.556 65.3747 73.4179 68.3778 71.6017C77.1921 66.2707 85.7583 60.4629 94.3834 54.8738C95.1206 54.3961 95.7315 53.5904 96.3762 52.9766C96.8389 52.5361 97.5428 52.21 97.877 51.6373C98.1993 51.085 99.0591 50.5771 99.5254 50.1245C99.959 49.7037 100.49 49.3999 100.928 48.9589C101.525 48.3571 98.9432 50.4268 98.812 50.5213",
    stroke: "url(#paint56_linear_213_16515)",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29883 121.1C5.29883 120.511 6.67826 119.55 7.14035 119.317C8.77407 118.494 10.2871 117.305 11.6919 116.143C14.2011 114.068 17.0288 112.601 19.7126 110.786C22.6105 108.827 25.1011 106.309 28.0777 104.425C31.1406 102.486 34.2595 100.496 37.144 98.2991C39.95 96.1621 43.2224 94.6959 46.1119 92.657C49.2265 90.4593 52.1594 87.8296 55.5226 86.0105C58.4978 84.4013 61.4709 82.4097 64.2198 80.4305C67.0428 78.3979 69.9711 76.5655 72.8556 74.6272C75.6593 72.743 78.8658 71.1652 81.4175 68.9479C83.351 67.2677 85.7104 65.8315 87.7897 64.3102C89.4466 63.098 91.0289 61.8394 92.6243 60.5529C93.6765 59.7044 94.8708 58.958 95.8227 57.9985C96.4971 57.3187 97.2707 56.9853 97.9263 56.3245C98.3988 55.8481 98.9697 55.2618 99.587 54.9852C99.9232 54.8346 100.299 54.5274 100.596 54.3032",
    stroke: "url(#paint57_linear_213_16515)",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79883 127.1C7.70688 124.6 7.67612 124.622 7.70688 124.6C9.98035 122.95 11.9297 120.808 14.1775 119.094C16.8949 117.023 19.8071 115.146 22.641 113.242C29.4094 108.693 36.3826 104.504 43.2216 100.073C50.3704 95.44 57.1973 90.317 64.2697 85.5643C69.6343 81.9592 75.2662 78.5271 80.3848 74.5777C84.0307 71.7647 87.7292 69.0041 91.5055 66.3688C93.1926 65.1914 95.0297 64.1264 96.5491 62.7479C97.0512 62.2924 97.5245 61.8843 98.1483 61.5699C99.2901 60.9944 100.418 59.9101 98.3698 61.4583",
    stroke: "url(#paint58_linear_213_16515)",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79883 133.6C4.33004 133.6 5.2233 132.807 5.70094 132.325C6.83048 131.187 8.39232 130.358 9.62515 129.312C15.2321 124.557 21.0048 119.736 27.0196 115.523C30.853 112.838 34.7229 110.183 38.5955 107.562C42.6021 104.85 46.4772 101.954 50.5895 99.4029C57.0714 95.382 63.0606 90.6328 69.3618 86.3455C77.568 80.7619 85.8096 75.1326 94.2725 69.94C95.5943 69.129 96.8569 68.0874 98.0368 67.1623C99.2039 66.2474 101.691 64.3144 98.5904 66.8151",
    stroke: "url(#paint59_linear_213_16515)",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29883 138.6C5.36748 138.047 8.21494 136.59 8.73932 136.232C10.1658 135.256 11.6549 134.393 13.1064 133.441C18.0299 130.216 22.7284 126.57 27.6346 123.273C31.5086 120.67 35.1506 117.694 38.9152 114.928C42.8264 112.055 46.7456 109.244 50.491 106.149C53.8458 103.376 57.2901 100.646 60.9474 98.2869C63.8152 96.4368 66.7874 94.6736 69.4109 92.4836C71.4736 90.7617 73.7681 89.3287 75.8323 87.5731C77.7973 85.9019 80.1803 84.7669 82.3153 83.3322C85.2498 81.3602 88.1734 79.398 91.0494 77.4049C92.6164 76.319 94.4564 75.2032 95.8839 73.9081C96.5872 73.2701 98.6245 71.5024 99.476 71.5024",
    stroke: "url(#paint60_linear_213_16515)",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29883 146.6C3.70019 146.6 4.70951 146.45 5.16003 146.053C5.9616 145.346 6.97693 144.9 7.80487 144.217C9.01861 143.216 10.2373 142.256 11.5446 141.378C14.1632 139.618 16.9044 137.652 19.27 135.562C22.6777 132.551 26.293 129.886 29.8494 127.08C37.0081 121.433 44.4534 116.115 51.5248 110.352C57.5754 105.421 64.1096 100.943 70.5185 96.5013C75.4036 93.1158 79.8199 89.1016 84.7515 85.7875C86.3827 84.6913 87.9423 83.4414 89.5122 82.2659C90.4602 81.556 91.5438 81.0611 92.3908 80.2074C93.3908 79.1994 95.3149 78.9224 96.155 77.8638C96.4857 77.4471 97.0229 77.0829 97.4836 76.8098C98.0788 76.4569 99.7733 75.7108 98.1479 76.413",
    stroke: "url(#paint61_linear_213_16515)",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70459 151.632C5.22711 151.567 5.86919 150.835 6.3038 150.566C8.33842 149.308 10.2326 147.762 12.1225 146.276C18.3293 141.392 24.6679 136.821 31.0669 132.214C38.4912 126.868 46.027 121.761 53.3329 116.267C57.1411 113.403 60.8543 110.186 64.9333 107.711C67.9373 105.889 70.9139 103.842 73.6674 101.647C77.5435 98.5579 81.5389 95.657 85.3047 92.4339C87.5024 90.553 89.2546 88.2788 91.2833 86.2338C92.8628 84.6417 94.7503 83.0943 96.5484 81.7697C97.0822 81.3765 97.5258 80.8427 98.0369 80.4305C98.7624 79.8455 99.196 79.435 97.9262 80.4305",
    stroke: "url(#paint62_linear_213_16515)",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92578 156.766C5.98866 155.695 6.91651 154.374 8.07499 153.418C9.36015 152.358 10.755 151.658 12.1222 150.74C16.462 147.823 20.6399 144.639 24.8544 141.539C31.6283 136.556 38.5983 131.817 45.2259 126.621C49.212 123.496 53.106 120.281 57.1338 117.21C60.7727 114.434 64.6828 112.064 68.3529 109.335C77.2023 102.755 86.3549 96.6293 95.2688 90.1399C96.3196 89.3749 97.1986 88.4302 98.0982 87.5234C98.6914 86.9255 100.818 85.3293 99.0331 86.9034",
    stroke: "url(#paint63_linear_213_16515)",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14746 159.891C5.89065 159.891 6.41389 159.219 6.93119 158.75C8.72379 157.124 10.6184 155.802 12.676 154.534C15.3554 152.884 18.0804 151.2 20.6598 149.4C23.4855 147.428 26.6253 145.978 29.4554 143.994C35.1783 139.981 40.7373 135.81 46.2841 131.544C48.8391 129.579 51.039 127.124 53.542 125.084C56.1763 122.937 59.0262 121.086 61.7226 119.032C71.3075 111.732 80.7439 104.328 90.7298 97.6172C92.7989 96.2267 94.6131 94.5722 96.4992 93.0167C97.0546 92.5586 97.5198 92.1158 98.1477 91.7643C98.4254 91.6087 99.3386 90.5712 98.8119 91.3674",
    stroke: "url(#paint64_linear_213_16515)",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25445 164.132C5.766 164.194 6.15532 163.826 6.47587 163.636C7.78035 162.863 8.97348 161.731 10.2525 160.883C16.9254 156.458 23.298 151.544 29.8981 146.995C33.2037 144.717 36.3678 142.289 39.641 139.976C41.355 138.766 42.8711 137.339 44.6724 136.244C46.7228 134.997 48.8632 133.868 50.8601 132.536C54.3873 130.184 57.8908 127.738 61.501 125.518C64.9321 123.407 68.036 120.871 71.3546 118.598C79.5086 113.015 86.8701 106.283 94.8753 100.519C95.6504 99.9608 96.9944 98.802 97.4832 97.9397C97.7508 97.4676 98.4282 97.1111 98.8241 96.7121C99.3232 96.209 99.8018 95.6471 100.362 95.2117",
    stroke: "url(#paint65_linear_213_16515)",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5688 165.471C12.1049 165.404 12.9683 164.456 13.3526 164.107C15.2642 162.373 17.5288 160.807 19.651 159.333C26.4632 154.603 33.2029 149.808 39.9118 144.924C47.1012 139.69 53.8945 133.752 61.3781 128.965C64.2212 127.146 66.9732 124.768 69.5956 122.628C71.9898 120.675 74.6158 119.018 77.0011 117.024C80.22 114.333 83.387 111.353 86.8547 109.001C88.1617 108.114 89.8837 107.146 90.8404 105.826C91.4753 104.95 92.6658 104.649 93.4484 103.917C94.1936 103.219 95.136 102.67 95.9333 102.032C96.7772 101.356 97.6777 101.079 98.5412 100.519C99.195 100.095 100.358 98.9626 99.4762 100.519",
    stroke: "url(#paint66_linear_213_16515)",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4336 165.248C18.9451 165.312 18.1503 165.211 18.6058 164.752C19.5494 163.801 21.2892 163.061 22.4316 162.334C25.1157 160.625 27.8875 158.634 30.3785 156.655C33.4656 154.201 36.6905 151.958 39.863 149.624C46.9352 144.42 54.1662 139.286 61.4892 134.446C64.7832 132.268 67.5703 129.483 70.6908 127.092C73.2107 125.162 75.5686 123.148 77.9488 121.054C82.2654 117.255 86.7789 113.599 91.2837 110.067C92.4123 109.182 93.5577 108.408 94.7774 107.661C95.2831 107.352 96.0204 106.765 96.5119 106.545C97.0893 106.287 97.4999 105.842 98.0373 105.541C98.3448 105.369 99.5506 104.214 98.8123 105.206",
    stroke: "url(#paint67_linear_213_16515)",
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6262 164.132C26.5347 164.547 25.7219 164.939 25.7897 164.851C26.1025 164.446 26.7789 164.336 27.192 163.996C31.454 160.481 35.608 156.797 39.8627 153.245C50.9342 144.001 62.4411 135.214 74.504 127.303C78.7645 124.509 83.3985 122.129 87.3961 118.933C89.6222 117.154 92.2806 115.731 94.3342 113.738C95.2747 112.825 96.3647 111.924 97.3727 111.133C97.982 110.656 98.7209 110.398 99.3533 109.993",
    stroke: "url(#paint68_linear_213_16515)",
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5973 165.025C33.6382 165.082 34.3441 165.136 34.9295 164.678C35.8992 163.917 36.751 163.025 37.7465 162.297C39.96 160.677 41.6563 158.827 43.5775 156.89C45.8132 154.637 48.4015 152.619 50.9831 150.789C53.1888 149.226 55.3474 147.562 57.5152 145.941C59.1823 144.694 60.9789 143.634 62.5466 142.258C64.4306 140.604 66.387 139.021 68.2545 137.347C70.3366 135.482 72.7572 134.065 74.8482 132.214C78.9783 128.558 83.7949 125.904 88.1831 122.616C90.7455 120.696 93.2384 118.591 95.884 116.813C96.3758 116.482 96.7043 116.057 97.151 115.697C97.6101 115.327 98.1535 114.997 98.5903 114.581C98.9216 114.265 99.2618 113.863 99.6113 113.589C99.8913 113.369 100.299 113.241 100.805 113.241",
    stroke: "url(#paint69_linear_213_16515)",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7902 164.132C41.71 165.342 41.5713 164.515 42.741 163.685C45.9946 161.378 49.1051 158.568 52.0903 155.923C54.3812 153.893 57.0772 152.271 59.4958 150.392C62.052 148.407 64.5613 146.389 67.1474 144.44C71.7722 140.955 76.0668 137.079 80.4332 133.28C83.1983 130.875 86.2844 128.851 89.0689 126.46C91.1867 124.642 93.5965 123.032 96.0562 121.723C96.3635 121.56 100.451 118.797 100.299 118.6",
    stroke: "url(#paint70_linear_213_16515)",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4332 164.578C48.6321 164.477 50.5922 162.751 50.7618 162.619C51.8855 161.745 52.7715 160.662 53.8741 159.779C55.3488 158.599 56.8998 157.548 58.3396 156.32C62.4748 152.793 66.3118 148.867 70.5182 145.432C74.4318 142.237 78.7186 139.598 82.5492 136.281C84.8876 134.256 87.3711 132.462 89.7333 130.478C91.681 128.842 94.0499 127.507 95.8841 125.79C96.7635 124.967 98.9906 123.415 99.7988 122.6",
    stroke: "url(#paint71_linear_213_16515)",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4118 164.802C55.3809 165.051 54.7065 165.512 54.8829 165.335C55.3664 164.847 55.7845 164.356 56.2976 163.896C57.3335 162.968 58.3431 161.982 59.4222 161.106C61.2271 159.641 62.6544 157.866 64.3797 156.32C68.0075 153.069 71.4028 149.565 75.6849 147.156C78.9544 145.317 81.7873 142.564 84.6405 140.137C86.7732 138.324 88.6434 136.362 91.0127 134.843C92.9082 133.627 94.393 131.848 96.1548 130.478C97.0786 129.759 98.9525 128.408 99.7988 127.6",
    stroke: "url(#paint72_linear_213_16515)",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2988 165.1C61.0935 165.1 63.0241 163.036 63.5552 162.52C65.1445 160.975 67.089 159.77 68.5866 158.093C70.9994 155.391 73.5653 152.659 76.5703 150.616C78.0897 149.583 79.3064 148.284 80.6053 146.995C81.756 145.853 83.1194 145.052 84.3695 144.044C87.3841 141.613 90.1944 139.035 93.4973 137C94.8514 136.166 98.4893 133.008 99.7988 132.1",
    stroke: "url(#paint73_linear_213_16515)",
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2988 164.1C60.3762 169.468 80.422 152.537 87.95 148.074C89.442 147.189 90.6544 146.007 91.9972 144.936C93.2715 143.921 94.7076 143.022 95.823 141.812C96.6678 140.894 97.744 140.153 98.8123 139.53C99.3597 139.21 99.698 137.78 99.698 138.91",
    stroke: "url(#paint74_linear_213_16515)",
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1265 165.248C73.1265 164.345 74.2669 163.976 74.8979 163.512C76.1887 162.562 77.57 161.708 78.8836 160.784C82.2135 158.441 85.214 155.492 88.6142 153.207C90.0985 152.21 91.3019 151.06 92.6122 149.859C93.5964 148.957 94.9177 148.374 95.8229 147.392C96.6239 146.522 97.8459 145.751 98.8122 145.048C99.4002 144.62 99.9337 144.157 100.584 143.82",
    stroke: "url(#paint75_linear_213_16515)",
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2988 164.6C80.2988 165.445 80.5193 164.401 81.7618 163.636C82.6241 163.105 83.5027 162.115 84.3083 161.454C85.6839 160.324 87.0853 159.09 88.3924 157.882C90.5196 155.917 92.7426 154.035 95.0353 152.302C95.835 151.698 96.5966 151.069 97.4341 150.517C98.3024 149.944 101.008 147.652 99.7986 148.6",
    stroke: "url(#paint76_linear_213_16515)",
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3047 165.025C87.0203 163.488 89.2214 162.379 90.8896 160.734C92.7188 158.931 94.7214 157.459 96.696 155.824C97.6776 155.011 98.6498 154.005 99.6976 153.294C100.88 152.492 100.352 153.506 99.919 154.088",
    stroke: "url(#paint77_linear_213_16515)",
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9478 164.355C91.9651 164.355 93.9453 162.79 94.2728 162.569C95.392 161.817 96.4348 160.914 97.4835 160.065C97.9513 159.686 100.883 158.1 99.7988 158.1",
    stroke: "url(#paint78_linear_213_16515)",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_213_16515)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 62,
    transform: "translate(4.29883 53.1001)",
    fill: "#E1DEF8",
    fillOpacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5093 75.974C88.5093 75.0438 89.2633 74.2898 90.1935 74.2898V81.0266H88.5093V75.974Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1348 82.7866C82.1348 81.8611 82.885 81.1108 83.8106 81.1108V87.8477H82.1348V82.7866Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9654 93.6582V90.9231L35.8946 90.4751V85.9007C35.8946 84.8475 35.5959 84.038 34.9986 83.4721C34.417 82.9062 33.5446 82.6233 32.3814 82.6233C31.5797 82.6233 30.8173 82.7569 30.0942 83.0241C29.8772 83.1043 29.67 83.1923 29.4728 83.2881C28.788 83.6207 27.894 83.4872 27.5005 82.8355C28.1293 82.301 28.8838 81.8923 29.7641 81.6094C30.6443 81.3107 31.5718 81.1614 32.5464 81.1614C34.1498 81.1614 35.3837 81.5622 36.2483 82.3639C37.1286 83.1499 37.5687 84.3524 37.5687 85.9715V93.6582H35.9654ZM31.6976 93.7761C30.7702 93.7761 29.9606 93.6268 29.2689 93.3281C28.593 93.0138 28.0742 92.5893 27.7127 92.0549C27.3512 91.5047 27.1704 90.8759 27.1704 90.1685C27.1704 89.5241 27.3197 88.9424 27.6184 88.4237C27.9328 87.8892 28.4358 87.4648 29.1275 87.1504C29.8348 86.8203 30.778 86.6553 31.9569 86.6553H36.2247V87.905H32.0041C30.8094 87.905 29.9763 88.1172 29.5047 88.5416C29.0489 88.966 28.8209 89.4926 28.8209 90.1214C28.8209 90.8287 29.0961 91.3946 29.6462 91.8191C30.1963 92.2435 30.9666 92.4557 31.9569 92.4557C32.9001 92.4557 33.7096 92.2435 34.3856 91.8191C35.0772 91.3789 35.5803 90.7502 35.8946 89.9327L36.2719 91.0881C35.9575 91.9055 35.4073 92.5578 34.6214 93.0452C33.8511 93.5325 32.8765 93.7761 31.6976 93.7761Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5093 81.0269V94.5005H90.1935V81.0269H88.5093Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7317 85.1463H25.2672V86.6554H16.7317V91.9135C16.7317 92.8771 15.9505 93.6583 14.9868 93.6583V77.1531H26.3047V78.6621H16.7317V85.1463Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1864 93.7762C44.0232 93.7762 43.1272 93.4618 42.4984 92.833C41.8696 92.2042 41.5553 91.3161 41.5553 90.1686V82.6705H39.3389V81.2793H41.5553V78.5442C42.4799 78.5442 43.2294 79.2937 43.2294 80.2183V81.2793H47.002V82.6705H43.2294V90.0743C43.2294 90.7974 43.4102 91.3554 43.7717 91.7484C44.149 92.1414 44.6835 92.3379 45.3751 92.3379C46.1139 92.3379 46.7269 92.1257 47.2142 91.7012L47.8037 92.9038C47.4736 93.2025 47.0728 93.4225 46.6012 93.564C46.1453 93.7055 45.6738 93.7762 45.1864 93.7762Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9239 93.6584V82.6706H62.7075V81.2794H64.9239V79.7232C64.9239 78.6229 65.2462 77.7348 65.8907 77.0588C66.5352 76.3829 67.4626 76.0449 68.673 76.0449C69.1446 76.0449 69.6005 76.1078 70.0406 76.2336C70.4807 76.3593 70.8502 76.5558 71.1488 76.823L70.5829 78.0727C70.3471 77.8684 70.0721 77.719 69.7576 77.6247C69.4433 77.5147 69.1053 77.4597 68.7437 77.4597C68.0364 77.4597 67.494 77.6561 67.1168 78.0491C66.7395 78.4421 66.5509 79.0237 66.5509 79.794V81.2794H70.3707C70.3707 82.0478 69.7478 82.6706 68.9795 82.6706H66.598V93.6584H64.9239Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7526 93.7764C76.6994 93.7764 75.7798 93.5799 74.9939 93.1869C74.2079 92.7939 73.5949 92.2044 73.1547 91.4185C72.7303 90.6326 72.5181 89.6501 72.5181 88.4711V81.2795H74.1922V88.2825C74.1922 89.6029 74.5144 90.6011 75.1589 91.277C75.8191 91.9372 76.7387 92.2673 77.9176 92.2673C78.7822 92.2673 79.5288 92.0944 80.1576 91.7486C80.8021 91.3871 81.2894 90.8683 81.6195 90.1924C81.9654 89.5164 82.1383 88.7069 82.1383 87.7638V82.9536C82.1383 82.0291 82.8878 81.2795 83.8124 81.2795V93.6585H82.209V91.3947C81.8239 92.0635 81.2973 92.6058 80.6292 93.0219C79.8118 93.5248 78.853 93.7764 77.7526 93.7764Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8594 93.6416C54.5703 93.6416 53.4386 93.3744 52.464 92.8399C51.4893 92.2898 50.727 91.5431 50.1768 90.5999C49.6266 89.641 49.3516 88.5485 49.3516 87.3224C49.3516 86.0963 49.6109 85.0117 50.1297 84.0685C50.6641 83.1254 51.3872 82.3866 52.2989 81.8521C53.2263 81.3019 54.2638 81.0269 55.4114 81.0269C56.5746 81.0269 57.6042 81.2941 58.5002 81.8285C59.4119 82.3473 60.1271 83.0861 60.6459 84.045C61.1646 84.9881 61.424 86.0806 61.424 87.3224C61.424 87.401 61.4161 87.4875 61.4004 87.5818C61.4004 87.6604 61.4004 87.7469 61.4004 87.8412H50.6248V86.5915H60.5044L59.8442 87.0866C59.8442 86.1906 59.6476 85.3968 59.2547 84.7052C58.8775 83.9978 58.3587 83.4476 57.6985 83.0546C57.0383 82.6617 56.2759 82.4652 55.4114 82.4652C54.5625 82.4652 53.8001 82.6617 53.1242 83.0546C52.4482 83.4476 51.9217 83.9978 51.5444 84.7052C51.1671 85.4125 50.9785 86.2221 50.9785 87.1338V87.3932C50.9785 88.3363 51.1828 89.1694 51.5916 89.8925C52.016 90.5999 52.5975 91.158 53.3364 91.5666C54.0909 91.9597 54.9476 92.1561 55.9065 92.1561C56.661 92.1561 57.3605 92.0225 58.005 91.7553C58.2168 91.6696 58.4188 91.5693 58.6111 91.4545C59.2615 91.0663 60.1489 91.0422 60.6459 91.6138C60.0956 92.274 59.404 92.777 58.5709 93.1229C57.7535 93.4687 56.8497 93.6416 55.8594 93.6416Z",
    fill: "#827677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1348 82.7869C82.1348 81.8614 82.885 81.1111 83.8106 81.1111C83.8106 82.0366 83.0603 82.7869 82.1348 82.7869Z",
    fill: "url(#paint79_linear_213_16515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0566 82.6267C69.0566 81.8825 69.6599 81.2793 70.404 81.2793V81.3214C70.404 82.0655 69.8008 82.6688 69.0566 82.6688V82.6267Z",
    fill: "url(#paint80_linear_213_16515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5703 91.4926C59.1762 90.9492 60.1079 91 60.6513 91.606C60.0453 92.1493 59.1136 92.0986 58.5703 91.4926Z",
    fill: "url(#paint81_linear_213_16515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5548 78.536C42.4425 78.5032 43.1887 79.1962 43.2215 80.0839L43.2274 80.2438C42.3397 80.2766 41.5935 79.5836 41.5607 78.6959L41.5548 78.536Z",
    fill: "url(#paint82_linear_213_16515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7212 92.0363C16.7158 92.9385 15.98 93.6656 15.0778 93.6602L14.9851 93.6596C14.9905 92.7574 15.7263 92.0303 16.6285 92.0357L16.7212 92.0363Z",
    fill: "url(#paint83_linear_213_16515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0853 83.4644C28.4744 83.7479 27.7507 83.4619 27.4987 82.8374L27.5457 82.8039C28.249 82.3034 29.2246 82.4651 29.7288 83.1657L29.0853 83.4644Z",
    fill: "url(#paint84_linear_213_16515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5093 75.974C88.5093 75.0438 89.2633 74.2898 90.1935 74.2898C90.1935 75.22 89.4394 75.974 88.5093 75.974Z",
    fill: "url(#paint85_linear_213_16515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2988 79.3424C76.2988 76.5519 78.561 74.2898 81.3515 74.2898H83.8778C83.8778 77.0803 81.6156 79.3424 78.8251 79.3424H76.2988Z",
    fill: "url(#paint86_linear_213_16515)"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.098 7.56259C101.712 6.04159 100.935 4.75641 99.5677 3.88843C97.9032 2.83724 96.0266 2.47621 94.1274 2.43602C90.6328 2.36157 87.1223 2.61742 83.6391 2.26525C80.6692 1.96213 77.6835 1.52664 74.7285 1.70272C72.3832 1.84453 70.0503 1.93139 67.7128 1.84453C65.1843 1.75176 62.6884 1.6123 60.1323 1.82976C55.5558 2.2162 50.931 2.08207 46.3456 1.74467C43.1962 1.51067 40.0283 1.29441 36.8972 1.26014C30.8111 1.19278 24.7101 0.831752 18.627 1.48528C15.3795 1.8339 12.0906 1.27669 8.84135 1.82445C6.45237 2.22448 4.60644 3.2934 3.50264 5.56773C2.4609 7.72799 2.5389 10.0785 2.40654 12.324C2.19618 16.007 2.31377 19.719 2.58794 23.4221C2.82194 26.5094 2.69489 29.6228 2.70612 32.725C2.73507 40.2401 2.74807 47.7549 2.77703 55.27C2.78412 57.7062 2.64821 60.1639 2.87689 62.5836C3.13451 65.272 3.05298 67.9548 3.09493 70.6398C3.30351 84.5772 2.9082 98.5185 3.41637 112.453C3.55996 116.336 3.45478 120.226 3.51623 124.112C3.65036 132.862 3.28223 141.621 3.85363 150.365C4.11894 154.476 3.69586 158.604 4.30034 162.709C4.65074 165.105 7.69858 167.14 10.0054 166.278C10.4338 166.116 10.8457 166.042 11.2871 166.04C13.0952 166.029 14.9027 166.04 16.7073 166.022C33.3075 165.862 49.9061 166.325 66.5002 165.764C69.9381 165.648 73.3817 165.748 76.8231 165.748C80.2555 165.749 83.6863 165.682 87.1264 165.891C90.7184 166.105 94.3653 166.49 97.9888 165.7C99.1233 165.453 99.8968 165.012 100.312 164.046C100.679 163.2 101.472 162.369 101.196 161.436C100.893 160.41 100.946 159.428 100.989 158.419C101.107 155.464 101.385 152.516 101.294 149.551C101.24 147.714 101.24 145.875 101.254 144.035C101.394 129.892 101.032 115.744 101.579 101.604C101.691 98.7156 101.715 95.8297 101.519 92.9326C101.37 90.6617 101.625 88.362 101.652 86.0747C101.831 72.1031 101.441 58.1279 102.007 44.1598C102.107 41.7655 102.08 39.3564 101.791 36.9715C101.651 35.8282 102.038 34.7462 102.071 33.6241C102.225 28.663 101.984 23.7043 102.416 18.7336C102.733 15.0464 103.036 11.2564 102.098 7.56215L102.098 7.56259ZM100.405 18.3671C99.9377 24.9419 100.413 31.5274 100.067 38.0924C99.3776 51.2056 99.9838 64.3238 99.7333 77.4388C99.6754 80.4375 99.8787 83.4547 99.637 86.4368C99.0851 93.2823 99.452 100.131 99.3191 106.978C99.1755 114.509 99.4497 122.055 99.1536 129.578C98.8269 137.862 99.0685 146.139 98.9267 154.417C98.8883 156.699 98.8978 158.984 98.8883 161.269C98.883 162.988 97.6758 164.297 95.9439 164.272C91.6889 164.201 87.4338 164.139 83.1794 163.936C79.0279 163.736 74.8603 163.869 70.7016 163.87C63.2647 163.874 55.8241 163.725 48.3956 163.941C38.8474 164.217 29.298 164.217 19.75 164.334C18.0004 164.354 16.2212 164.412 14.4786 164.444C12.2604 164.484 9.99318 164.45 7.76258 164.228C6.72793 164.125 6.25048 163.327 6.20315 162.367C6.12338 160.802 6.11215 159.232 6.11038 157.664C6.10506 150.572 6.11215 143.476 6.12338 136.382C6.12338 135.904 6.14524 135.436 5.68613 135.071C6.0962 134.485 6.12338 133.955 6.12338 133.398C6.10329 128.248 6.30834 123.087 6.04361 117.95C5.51004 107.424 5.85689 96.8953 5.68789 86.3701C5.65716 84.2641 5.74934 82.157 5.64948 80.0571C5.045 67.3505 5.40603 54.6349 5.28668 41.9239C5.20336 33.4671 5.1815 25.0091 5.15432 16.5547C5.15255 15.7871 5.12005 15.0574 4.56283 14.3471C5.15668 14.171 5.16199 13.7373 5.15668 13.2634C5.14368 11.6952 5.14604 10.1252 5.162 8.55819C5.1874 6.04215 7.05693 4.12362 9.55815 4.12528C24.1921 4.13237 38.8255 4.17432 53.4577 4.17078C56.8972 4.16901 60.3516 4.11287 63.7699 4.28896C67.1735 4.46505 70.5664 4.52885 73.964 4.53772C75.053 4.53949 76.093 4.104 77.2045 4.2399C81.8861 4.80598 86.5943 4.37994 91.283 4.58143C93.2962 4.66475 95.3183 4.89934 97.2805 5.43291C97.5328 5.50204 97.8123 5.62732 97.9701 5.81758C99.023 7.06436 99.9779 8.24619 100.246 10.0507C100.651 12.8432 100.593 15.6133 100.405 18.3651L100.405 18.3671Z",
    fill: "#827677"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_213_16515",
    x: 0.298828,
    y: 49.1001,
    width: 104,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_213_16515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_213_16515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_16515",
    x1: 86.148,
    y1: 26.126,
    x2: 106.974,
    y2: 20.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_213_16515",
    x1: 76.6441,
    y1: 41.2464,
    x2: 110.127,
    y2: 32.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_213_16515",
    x1: 68.8465,
    y1: 47.2112,
    x2: 111.447,
    y2: 34.0956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_213_16515",
    x1: 61.9106,
    y1: 56.043,
    x2: 113.849,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_213_16515",
    x1: 55.5068,
    y1: 66.4818,
    x2: 115.818,
    y2: 48.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_213_16515",
    x1: 49.7379,
    y1: 73.4704,
    x2: 116.992,
    y2: 52.7131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_213_16515",
    x1: 41.6586,
    y1: 80.4501,
    x2: 119.667,
    y2: 55.1276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_213_16515",
    x1: 33.7108,
    y1: 86.5363,
    x2: 121.317,
    y2: 56.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_213_16515",
    x1: 26.7516,
    y1: 95.7389,
    x2: 124.04,
    y2: 62.5196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_213_16515",
    x1: 20.6186,
    y1: 105.663,
    x2: 125.422,
    y2: 70.9006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_213_16515",
    x1: 15.1074,
    y1: 109.399,
    x2: 126.344,
    y2: 71.8098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_213_16515",
    x1: 10.1875,
    y1: 118.8,
    x2: 129.15,
    y2: 79.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_213_16515",
    x1: 3.90895,
    y1: 127.25,
    x2: 130.795,
    y2: 85.3754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_213_16515",
    x1: -1.40917,
    y1: 133,
    x2: 131.604,
    y2: 87.9165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_213_16515",
    x1: -2.57039,
    y1: 139.294,
    x2: 131.923,
    y2: 93.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_213_16515",
    x1: -2.08187,
    y1: 149.079,
    x2: 130.862,
    y2: 102.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_213_16515",
    x1: -3.07819,
    y1: 161.819,
    x2: 132.481,
    y2: 115.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_213_16515",
    x1: -2.44379,
    y1: 175.997,
    x2: 132.657,
    y2: 131.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_213_16515",
    x1: -1.53503,
    y1: 180.844,
    x2: 130.392,
    y2: 134.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_213_16515",
    x1: -2.57352,
    y1: 190.334,
    x2: 129.968,
    y2: 144.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_213_16515",
    x1: -1.50885,
    y1: 192.399,
    x2: 122.52,
    y2: 149.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_213_16515",
    x1: -0.350792,
    y1: 190.25,
    x2: 104.55,
    y2: 157.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_213_16515",
    x1: -0.250629,
    y1: 187.327,
    x2: 87.8833,
    y2: 161.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_213_16515",
    x1: 0.91008,
    y1: 184.218,
    x2: 73.2378,
    y2: 164.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_213_16515",
    x1: 1.96412,
    y1: 181.676,
    x2: 58.4122,
    y2: 168.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_213_16515",
    x1: 2.35022,
    y1: 179.346,
    x2: 48.3725,
    y2: 168.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_213_16515",
    x1: 2.7876,
    y1: 176.818,
    x2: 39.8691,
    y2: 168.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_213_16515",
    x1: 3.84906,
    y1: 174.465,
    x2: 33.6242,
    y2: 167.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_213_16515",
    x1: 3.54159,
    y1: 172.218,
    x2: 28.5929,
    y2: 165.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_213_16515",
    x1: 4.4052,
    y1: 169.549,
    x2: 20.0337,
    y2: 165.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_213_16515",
    x1: 5.30353,
    y1: 167.407,
    x2: 14.6753,
    y2: 164.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_213_16515",
    x1: 3.35164,
    y1: 14.1835,
    x2: 16.4821,
    y2: 8.92991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_213_16515",
    x1: 2.42903,
    y1: 19.3902,
    x2: 23.5296,
    y2: 10.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_213_16515",
    x1: 2.03196,
    y1: 24.4524,
    x2: 28.1985,
    y2: 14.0969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_213_16515",
    x1: 3.35458,
    y1: 26.8464,
    x2: 32.9784,
    y2: 14.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_213_16515",
    x1: 2.69012,
    y1: 32.4971,
    x2: 39.5445,
    y2: 16.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_213_16515",
    x1: 1.68537,
    y1: 37.8634,
    x2: 45.1371,
    y2: 19.8483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_213_16515",
    x1: 3.02383,
    y1: 40.8001,
    x2: 49.2301,
    y2: 21.4038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_213_16515",
    x1: 1.69883,
    y1: 47.0001,
    x2: 54.4375,
    y2: 24.7659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_213_16515",
    x1: 1.30936,
    y1: 53.4796,
    x2: 61.9425,
    y2: 27.9094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_213_16515",
    x1: 1.24414,
    y1: 59.8169,
    x2: 68.1468,
    y2: 32.6525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_213_16515",
    x1: 0.244455,
    y1: 65.9871,
    x2: 75.1664,
    y2: 35.3585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_213_16515",
    x1: -0.148681,
    y1: 68.5341,
    x2: 79.766,
    y2: 34.6241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_213_16515",
    x1: -0.465579,
    y1: 74.1135,
    x2: 86.1226,
    y2: 37.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_213_16515",
    x1: 0.372492,
    y1: 80.8574,
    x2: 98.6392,
    y2: 37.7268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_213_16515",
    x1: -0.636818,
    y1: 87.6903,
    x2: 108.701,
    y2: 38.2076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_213_16515",
    x1: -1.5102,
    y1: 94.9114,
    x2: 114.06,
    y2: 43.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_213_16515",
    x1: -2.06202,
    y1: 99.9725,
    x2: 120.704,
    y2: 44.0675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_213_16515",
    x1: -1.8266,
    y1: 102.26,
    x2: 119.688,
    y2: 43.8664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_213_16515",
    x1: -1.4842,
    y1: 107.227,
    x2: 120.745,
    y2: 48.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_213_16515",
    x1: -1.44465,
    y1: 111.126,
    x2: 117.785,
    y2: 51.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_213_16515",
    x1: -2.46927,
    y1: 108.014,
    x2: 117.798,
    y2: 48.0422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_213_16515",
    x1: -1.76018,
    y1: 116.304,
    x2: 118.556,
    y2: 56.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_213_16515",
    x1: -1.46422,
    y1: 120.995,
    x2: 118.44,
    y2: 62.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_213_16515",
    x1: -1.71591,
    y1: 126.305,
    x2: 118.29,
    y2: 67.6796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_213_16515",
    x1: -1.90042,
    y1: 131.442,
    x2: 117.17,
    y2: 72.6531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_213_16515",
    x1: -0.612418,
    y1: 134.59,
    x2: 117.624,
    y2: 75.0892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_213_16515",
    x1: -0.895467,
    y1: 141.139,
    x2: 117.845,
    y2: 82.2182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_213_16515",
    x1: -1.3571,
    y1: 147.032,
    x2: 116.687,
    y2: 88.5057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_213_16515",
    x1: -1.53545,
    y1: 154.005,
    x2: 118.142,
    y2: 95.6076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_213_16515",
    x1: -0.822687,
    y1: 158.729,
    x2: 117.272,
    y2: 101.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_213_16515",
    x1: -2.04253,
    y1: 167.744,
    x2: 118.664,
    y2: 111.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_213_16515",
    x1: -1.40736,
    y1: 173.174,
    x2: 119.517,
    y2: 118.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_213_16515",
    x1: -1.23662,
    y1: 177.927,
    x2: 119.577,
    y2: 121.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_213_16515",
    x1: -0.95117,
    y1: 180.537,
    x2: 117.996,
    y2: 124.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_213_16515",
    x1: -0.108553,
    y1: 184.817,
    x2: 119.317,
    y2: 127.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_213_16515",
    x1: 5.83419,
    y1: 185.196,
    x2: 118.327,
    y2: 132.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_213_16515",
    x1: 13.1937,
    y1: 183.403,
    x2: 116.214,
    y2: 135.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_213_16515",
    x1: 21.0037,
    y1: 181.325,
    x2: 114.836,
    y2: 137.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_213_16515",
    x1: 29.7913,
    y1: 180.608,
    x2: 116.054,
    y2: 142.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_213_16515",
    x1: 38.1255,
    y1: 178.584,
    x2: 114.073,
    y2: 145.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_213_16515",
    x1: 45.9555,
    y1: 177.172,
    x2: 112.742,
    y2: 149.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_213_16515",
    x1: 51.9321,
    y1: 176.707,
    x2: 111.519,
    y2: 152.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_213_16515",
    x1: 57.7313,
    y1: 175,
    x2: 110.007,
    y2: 153.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_213_16515",
    x1: 63.6692,
    y1: 173.138,
    x2: 107.635,
    y2: 153.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_213_16515",
    x1: 71.3417,
    y1: 171.676,
    x2: 106.912,
    y2: 155.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_213_16515",
    x1: 79.0114,
    y1: 169.877,
    x2: 105.221,
    y2: 158.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_213_16515",
    x1: 84.3222,
    y1: 168.633,
    x2: 104.028,
    y2: 160.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_213_16515",
    x1: 91.4219,
    y1: 166.232,
    x2: 101.87,
    y2: 161.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_213_16515",
    x1: 82.0258,
    y1: 83.2896,
    x2: 84.3472,
    y2: 82.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_213_16515",
    x1: 68.9691,
    y1: 83.0856,
    x2: 70.8476,
    y2: 82.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_213_16515",
    x1: 58.1771,
    y1: 91.7164,
    x2: 60.0686,
    y2: 92.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_213_16515",
    x1: 41.0683,
    y1: 78.4389,
    x2: 42.0723,
    y2: 80.7991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_213_16515",
    x1: 16.8363,
    y1: 91.5468,
    x2: 14.4695,
    y2: 92.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_213_16515",
    x1: 30.2848,
    y1: 82.8767,
    x2: 28.3676,
    y2: 81.4386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_213_16515",
    x1: 88.3998,
    y1: 76.4793,
    x2: 90.7328,
    y2: 75.6678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_213_16515",
    x1: 75.8062,
    y1: 80.8582,
    x2: 85.0569,
    y2: 76.0319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTarotCard);
export default __webpack_public_path__ + "static/media/back-tarot-card.196fffe8fc3bdc60beb8c48445b05959.svg";
export { ForwardRef as ReactComponent };